import { render, staticRenderFns } from "./VotingRightsCreate.vue?vue&type=template&id=7b13f8b8"
import script from "./VotingRightsCreate.vue?vue&type=script&lang=js"
export * from "./VotingRightsCreate.vue?vue&type=script&lang=js"
import style0 from "./VotingRightsCreate.vue?vue&type=style&index=0&id=7b13f8b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports